import React, {useState} from 'react';
import {
  Alert,
  Platform,
  SafeAreaView,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {useSelector} from 'react-redux';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import 'react-native-get-random-values';
import FastImage from 'src/Utils/FastImage';

import {
  BottomTab,
  BottomTabButton,
} from 'src/Modules/TabViews/FooterComponents';

import {joinHunt} from 'src/Utils/huntFunctions';

/////////////// components

import UserProfileIcon from 'src/Modules/UserProfileIcon';

import HuntListCard from 'src/Modules/HuntListCard';

import CallSupportLine from 'src/HeaderComponents/CallSupportLine';
import SearchBar from 'src/Modules/CommonView/SearchBar';
import isIphoneX from 'src/Utils/IphoneXHelper';
import {createHunt} from '../Utils/huntFunctions';

import {navigationRef} from 'src/Nav/navigationHelpers';
import CustomActivityIndicator from '../Modules/CommonView/CustomActivityIndicator';
import {api_delete_user_or_group} from '../Utils/apiCalls';

const isX = isIphoneX();

const EventHome = () => {
  const {width} = useWindowDimensionsSafe();

  const userId = useSelector((state) => state.user?.userId);

  const [teamNameFilter, setTeamNameFilter] = useState(null);

  const event = useSelector((state) => state.event);

  const createGroup = async (
    name,
    routeIdOverride = null,
    additionalHuntData = {},
  ) => {
    console.log('EventHome: createGroup');
    let {info} = event;
    const {groupType} = info;

    const theme =
      groupType == 'Normal'
        ? 'Standard'
        : groupType == 'BvB'
        ? 'Standard'
        : groupType;

    console.log('creating a new group with name', {
      name,
      event,

      routeIdOverride,
    });

    const data = {...info, teamName: name, theme, ...additionalHuntData};
    if (!!routeIdOverride) {
      data.routeId = routeIdOverride || null;
      data.route_id = routeIdOverride || null;
      data.routeIdOverride = routeIdOverride || null;
    }

    console.log('createHunt', {data});

    // return global.devAlert(data);

    const newGroup = await createHunt(data);

    navigationRef.navigate('ConfirmModal', {
      titleText: `Team \`${name}\` Created`,
      titleBodyText: 'Do you wish to join this team now?',
      confirmText: 'Join Team Now',
      cancelText: 'Maybe Later',
      handleConfirm: async () => {
        navigationRef.closeModal('ConfirmModal', 'EventHome1');
        joinHunt(newGroup?.groupId, userId, 'Joining Group');
      },
    });
  };

  const onPromptSubmit = (newName, routeId = null) => {
    console.log('EventHome: onPromptSubmit');
    if (!newName) {
      return Alert.alert('A team name is required!');
    }
    const {groups} = event;
    let allNames = groups?.map?.((group) =>
      (group?.teamName + '')?.toLowerCase?.(),
    );
    console.log('all the team names are: ', allNames);
    if (newName?.length > 15) {
      return Alert.alert('Please enter a shorter name!');
    } else if (allNames?.toLowerCase?.()?.includes?.(newName + '')) {
      return Alert.alert('That name is already taken!');
    }
    navigationRef.goBack(null);
    createGroup(newName, routeId);
  };

  const showCreateGroupModal = () => {
    console.log('EventHome: showCreateGroupModal');
    let {info} = event;

    const {allRoutes = [], packageType = ''} = info;
    const options = {
      titleText: `What do you want to name your group?`,
      titleBodyText:
        'Pick a fun and exciting name that will help your group stand out from the pack!',
      confirmText: 'Create Group',
      showPrompt: true,
      cancelText: 'Cancel',
      handleConfirm: (newTeamName) => {
        onPromptSubmit(newTeamName);
      },
    };

    console.log({allRoutes});

    if (packageType?.includes?.('connected')) {
      options.titleText = `Please select which hunt you want to do and name your group`;
      options.dropDownOptions = [
        {section: true, label: 'Which hunt do you want to do?'},
      ];
      allRoutes?.map?.((route, key) => {
        options.dropDownOptions.push({
          label: route?.city_name + ' - ' + route.route_name,
          value: route.routeId || route.route_id,
          key,
        });
      });
      options.placeholder = 'Pick your team name';
      options.placeholderDropDown = 'Select your hunt';
      options.handleConfirm = (newTeamName, routeId) => {
        if (!routeId) {
          return Alert.alert('Please select a hunt');
        }
        onPromptSubmit(newTeamName, routeId);
      };
    }

    navigationRef.navigate('ConfirmModal', options);
  };

  console.log('EventHome: render');

  if (!event?.info) {
    return (
      <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
        <CustomActivityIndicator />
      </View>
    );
  }

  let {groups, info} = event;
  let hunt = {...info};

  const {company = '', packageType = ''} = info;

  hunt.name = hunt.company ? hunt.company + '' : hunt.groupType + '';

  if (packageType?.includes?.('connected')) {
    hunt.city = 'connected';
  }

  let shownGroups = [...(groups || [])];
  shownGroups = shownGroups.sort((a, b) =>
    a?.teamName > b?.teamName ? 1 : -1,
  );
  var hasTestTeams = false;
  shownGroups?.map?.((team) => {
    if (team?.teamName?.toLowerCase?.()?.includes('test')) {
      hasTestTeams = 1;
    }
  });

  if (shownGroups && teamNameFilter) {
    shownGroups = shownGroups?.filter((a) =>
      a?.teamName?.includes?.(teamNameFilter),
    );
  }

  return (
    <SafeAreaView style={{flex: 1, backgroundColor: global?.color?.white}}>
      <CallSupportLine />
      <View style={{backgroundColor: 'black', width, height: 120}}>
        <HuntListCard
          hideNavigate
          hunt={hunt}
          disableTouch={true}
          hideFlag={true}
          replaceReviewsWithText={'Custom Event'}
          width={width}
        />

        <TouchableOpacity
          onPress={() => navigationRef.goBack(null)}
          style={{
            position: 'absolute',
            top: 15,
            left: 15,
            width: 40,
            height: 40,
          }}>
          <FastImage
            resizeMode={FastImage?.resizeMode?.contain}
            source={require('src/Images/BackButton.png')}
            style={{width: 20, height: 20}}
          />
        </TouchableOpacity>
      </View>
      <SearchBar
        round
        lightTheme
        containerStyle={{
          width: width - 50,
          height: 40,
          backgroundColor: 'transparent',
          borderWidth: 0,
          marginLeft: 25,
          marginTop: 5,
          borderBottomColor: 'transparent',
          borderTopColor: 'transparent',
        }}
        searchIcon={{size: 16}}
        onChangeText={(teamNameFilter) => setTeamNameFilter(teamNameFilter)}
        value={teamNameFilter}
        onClear={(teamNameFilter) => setTeamNameFilter(teamNameFilter)}
        inputContainerStyle={{
          backgroundColor: global?.color?.white,
          borderWidth: 2,
          borderBottomWidth: 2,
          borderColor: 'orange',
          borderStyle: 'solid',
          height: 40,
        }}
        icon={{name: 'search', size: 22, style: {top: 20, left: 20}}}
        inputStyle={{
          height: 35,
          backgroundColor: global?.color?.white,
          borderRadius: 20,
          marginLeft: 10,
          color: global?.color?.gray3,
          marginRight: 5,
          paddingLeft: 30,
          paddingBottom: Platform.OS == 'android' ? 11 : 0,
        }}
        placeholder="Search for teams"
      />
      <ScrollView
        testID={'lobbyScroll'}
        style={{flex: 1, paddingTop: 25, paddingBottom: 120, marginTop: 20}}>
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            flexWrap: 'wrap',
            paddingHorizontal: 20,
          }}>
          <TouchableOpacity
            testID={'createGroup'}
            onPress={() => showCreateGroupModal()}
            style={{
              width: 95,
              height: 80,
              margin: 5,
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <FastImage
              source={require('src/Images/addPlayerButton.png')}
              style={{width: 70, height: 64}}
              resizeMode={FastImage?.resizeMode?.cover}
            />
            <Text
              style={{
                color: global?.color?.gray3,
                fontFamily: global?.font.circular,
                fontSize: 12,
              }}>
              Create Team
            </Text>
          </TouchableOpacity>
          {!!groups &&
            shownGroups?.map?.((group) => {
              if (group.deleted) {
                return;
              }
              let photoUrl = group?.groupPhoto;
              if (!photoUrl && group?.players) {
                let firstPlayer = Object.values(group?.players)[0];
                photoUrl = firstPlayer?.photoUrl;
              }

              let renderTeamName =
                group?.route && Number.isInteger(group?.route)
                  ? `${
                      group?.teamName?.length > 8
                        ? `${group?.teamName?.substr(0, 6)}..`
                        : group?.teamName
                    } (${group?.route})`
                  : group?.teamName;
              return (
                <View
                  key={`${group?.groupId}grp`}
                  style={{marginLeft: 5, marginRight: 5, marginBottom: 10}}>
                  <UserProfileIcon
                    user={{info: {firstName: renderTeamName, photoUrl}}}
                    nameOverride={renderTeamName}
                    showName
                    handleSignInPress={async () => {
                      let joinText = 'Do you want to join this team now?';
                      console.log({company});
                      if (company && company?.includes?.('21+')) {
                        joinText =
                          'You must be 21 years or older to play this scavenger hunt. While no drinking is required on this hunt, you may be asked to enter bars, many of which require you be of legal drinking age. Please confirm that you are of legal drinking age below before you play and to join this group. Consider playing our regular scavenger hunts instead.';
                      }
                      navigationRef.navigate('ConfirmModal', {
                        titleText: `Join ${group?.teamName}`,
                        titleBodyText: joinText,
                        confirmText: 'Join Team Now',
                        cancelText: 'Maybe Later',
                        handleConfirm: async () => {
                          navigationRef.closeModal(
                            'ConfirmModal',
                            'EventHome2',
                          );
                          joinHunt(group?.groupId, userId, 'Joining Group');
                        },
                      });
                    }}
                  />
                </View>
              );
            })}
        </View>
        <View style={{height: 90}} />
      </ScrollView>
      <BottomTab
        height={isX ? 75 : 65}
        tabStyle={{
          alignItems: 'flex-start',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
        }}>
        <BottomTabButton
          text={'Go Back'}
          iconName={'arrow-left-circle'}
          handlePress={() =>
            navigationRef.navigate('LandingPageMain', null, 'Event Home')
          }
          buttonStyle={{marginTop: 5}}
          active={false}
        />
        {!!Platform.OS != 'web' && (
          <BottomTabButton
            text={'FAQ'}
            iconName={'question'}
            handlePress={() => navigationRef.navigate('FAQ')}
            buttonStyle={{marginTop: 5}}
            active={false}
          />
        )}

        <BottomTabButton
          text={'Dashboard'}
          iconName={'user'}
          handlePress={() => navigationRef.navigate('EventDashboard')}
          buttonStyle={{marginTop: 5}}
          active={false}
        />
        {!!hasTestTeams && (
          <BottomTabButton
            text={'Delete Testers'}
            iconName={'minus'}
            handlePress={async () => {
              shownGroups?.map?.((team) => {
                if (team?.teamName?.toLowerCase?.()?.includes('test')) {
                  const groupId = team?.groupId || 'error';
                  api_delete_user_or_group({
                    id: groupId,
                    type: 'group',
                  });
                  console.log({groupId, shownGroups});
                }
              });
            }}
            buttonStyle={{marginTop: 5}}
            active={false}
          />
        )}
        {!!__DEV__ && (
          <BottomTabButton
            text={'Delete Teams'}
            iconName={'minus'}
            handlePress={async () => {
              shownGroups?.map?.((team) => {
                const groupId = team?.groupId || 'error';
                api_delete_user_or_group({
                  id: groupId,
                  type: 'group',
                });
                console.log({groupId, shownGroups});
              });
            }}
            buttonStyle={{marginTop: 5}}
            active={false}
          />
        )}
        <BottomTabButton
          text={'Create Team'}
          iconName={'plus'}
          handlePress={() => showCreateGroupModal()}
          buttonStyle={{marginTop: 5}}
          active={false}
        />
      </BottomTab>
    </SafeAreaView>
  );
};

// eslint-disable-next-line
export default EventHome;
